module.exports = __webpack_public_path__ + "img/chess.c8286935.png";